import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-task-popup',
  templateUrl: './new-task-popup.component.html',
  styleUrls: ['./new-task-popup.component.scss']
})
export class NewTaskPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
